import axios from "axios";
import { takeLatest, put } from "redux-saga/effects";

import { API_BASE_URI } from "../ApiCall";
import { AllureQuarterlyPlanActionTypes } from "./AllureQuarterlyPlan.type";
import { formatQuery } from "../Utils";

export function* fetchAllAllureQuarterlyPlans(action: any): any {
    try {
        const response = yield axios.get(`${API_BASE_URI}/allure-quarterly-plan?${formatQuery(action)}`);
        yield put({
            type: AllureQuarterlyPlanActionTypes.FETCH_ALL_ALLURE_QUARTERLY_PLAN_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        yield put({
            type: AllureQuarterlyPlanActionTypes.FETCH_ALL_ALLURE_QUARTERLY_PLAN_FAILURE,
            payload: error,
        });
    }
}

export function* fetchOneAllureQuarterlyPlans(action: any): any {
    try {
        const response = yield axios.get(
            `${API_BASE_URI}/allure-quarterly-plan/${action.payload}`
        );
        yield put({
            type: AllureQuarterlyPlanActionTypes.FETCH_ONE_ALLURE_QUARTERLY_PLAN_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        yield put({
            type: AllureQuarterlyPlanActionTypes.FETCH_ONE_ALLURE_QUARTERLY_PLAN_FAILURE,
            payload: error,
        });
    }
}

export function* watcherFetchAllAllureQuarterlyPlans() {
    yield takeLatest(AllureQuarterlyPlanActionTypes.FETCH_ALL_ALLURE_QUARTERLY_PLAN, fetchAllAllureQuarterlyPlans);
}

export function* watcherFetchOneAllureQuarterlyPlans() {
    yield takeLatest(AllureQuarterlyPlanActionTypes.FETCH_ONE_ALLURE_QUARTERLY_PLAN, fetchOneAllureQuarterlyPlans);
}
